import jwt from "jwt-decode";

const tokenKey = "token";

const getToken = () => {
  return localStorage.getItem(tokenKey);
};

const setToken = (newToken) => {
  localStorage.setItem(tokenKey, newToken);
};

const clearToken = () => {
  localStorage.removeItem(tokenKey);
};

const getAttribute = (atribute) => {
  return jwt(getToken())[atribute];
};

const getRole = () => {
  const tokenDecoded = jwt(getToken());

  const key = Object.keys(tokenDecoded).find((k) => k.includes("role"));

  return tokenDecoded[key];
};

const getExpiresAt = () => {
  return getAttribute("exp");
};

export const tokenController = {
  getToken,
  setToken,
  clearToken,
  getAttribute,
  getRole,
  getExpiresAt,
};
